import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { Icon, IconColor } from "../Icon";

const className = bemClassNames("encrypted-symbol-component");

export const EncryptedSymbol: FunctionComponent = () => (
    <div className={className()}>
        <Icon iconCode={IconCode.userLock} color={IconColor.textSecondary} />
    </div>
);
